export const booleanToString = (boolean) => {
  return boolean ? 'Sim' : 'Não'
}